import React, { useState, useEffect } from "react";
import "./Trustnew.css";
import pic1 from "../assets/test1.png";
import pic2 from "../assets/test3.png";
import pic3 from "../assets/test2.png";
import pic4 from "../assets/test4.png";
import quoteimg from "../assets/quoteimg.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import next from "../assets/icon2.svg";
import prev from "../assets/icon1.svg";
import useLocation from "../../utils/Location";

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div className="slick-arrow slick-next" onClick={onClick}>
      <img src={next} alt="Next" className="arrows" />
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="slick-arrow slick-prev" onClick={onClick}>
      <img src={prev} alt="Previous" className="arrows" />
    </div>
  );
}


export default function Trustnew() {
  
  const {countryCode} = useLocation();
  const testimonialData = [
    {
      name: "Ananya Shrivastava",
      location: "Delhi, India",
      profile: pic1,
      description:
        "Listing my flat took less than 10 minutes. Got genuine buyer calls the same day.",
      id: 1,
    },
    {
      name: "Arjun Khanna",
      location: "Mumbai, India",
      profile: pic2,
      description:
        "Loved the NFC card feature. Shared my listings in one tap and closed deals faster.",
      id: 2,
    },
    {
      name: "Sneha Iyer",
      location: "Bangalore, India",
      profile: pic3,
      description:
        "The dashboard is so easy to use. I tracked leads and sold my property without agents.",
      id: 3,
    },
    {                                              
      name: "Nandani Singh",
      location: "Pune, India",
      profile: pic4,
      description:
        "No hidden charges, no middlemen. I kept every rupee from my property sale.",
      id: 4,
    },
  ];

  const [slidesToShow, setSlidesToShow] = useState(2);
  const [centerMode, setCenterMode] = useState(true);
  const [centerPadding, setCenterPadding] = useState("30px");

  useEffect(() => {
    const updateSettings = () => {
      const width = window.innerWidth;

      if (width >= 1200) {
        setSlidesToShow(3);
        setCenterMode(false);
        setCenterPadding("0");
      } 
      else if (width >= 992) {
        setSlidesToShow(2);
        setCenterMode(true);
        setCenterPadding("20px");
      } else if (width >= 800) {
        setSlidesToShow(2);
        setCenterMode(true);
        setCenterPadding("20px");
         } else if (width >= 650) {
        setSlidesToShow(1);
        setCenterMode(true);
        setCenterPadding("100px");
      } else if (width >= 450) {
        setSlidesToShow(1);
        setCenterMode(true);
        setCenterPadding("60px");
      } else {
        setSlidesToShow(1);
        setCenterMode(true);
        setCenterPadding("20px");
      }
    };

    updateSettings();
    window.addEventListener("resize", updateSettings);
    return () => window.removeEventListener("resize", updateSettings);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    centerMode,
    centerPadding,
     nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div id="testimonialsnew" className="wrapper">
       <h2>Trusted by Property Sellers</h2>

        <div className="mobilecards">
          <Slider {...settings}>
           {testimonialData.map((item) => (
          <div className="testimonialWrapper">
            <div className="testimonialBox">
              <div className="info">
                <div className="profile-left">
                  <div className="profileBox">
                    <img src={item.profile} alt="error" />
                  </div>
                  <div className="">
                    <p className="profileName">{item.name}</p>
                    <p className="profileLocation">{countryCode === "ae" ? "Dubai" : item.location}</p>
                  </div>
                </div>
                <div className="profile-right">
                  <img src={quoteimg} alt="error" />
                </div>
              </div>
              <p className="profileDescription">{item.description}</p>
            </div>
          </div>
        ))}
          </Slider>
        </div>
    </div>
  );
}
